// @ts-nocheck
import * as Types from '../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type VersionableFragment = { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } };

export const VersionableFragmentDoc = gql`
    fragment Versionable on ReadyPlanAggregateVersion {
  id
  version
  status {
    code
  }
}
    `;